export default __webpack_public_path__ + "static/media/machine-ca.1157cd00.png";